export default {
  unauthorized: 'غير مصرح',
  unauthenticated: 'غير مصرح',
  unauthenticated_desc: 'يجب عليك التسجيل للدخول للوصول إلى هذه الصفحة',
  login: 'تسجيل الدخول',
  try_again: 'إعادة المحاولة',
  general_error: 'هناك خطأ ما!',
  not_found_title: 'هذه الصفحة غير موجودة',
  go_to_home_page: 'اذهب إلى الصفحة الرئيسية',
  failed_to_load_data: 'فشل في تحميل البيانات!',
  your_request_failed: 'يبدو أن طلبك فشل لسبب ما!',
  application_not_found: 'عذراً، لا يمكن الوصول لبيانات الطلب',
  not_found_desc: 'عذراً، يبدو أن عنوان الموقع الذي أدخلته غير صحيح',
  something_went_wrong: 'هناك خطأ ما!',
  unexpected_error: 'حدث خطأ غير متوقع في التطبيق',
  otp_trials_exceeded:
    'لقد وصلت للحد الأقصى لعدد مرات الإدخال الخاطئ لرمز التحقق، يمكنك المحاولة مرة أخرى بعد {{minutes}} دقيقة من الآن',

  // API error codes
  DocumentNotFound: 'الوثيقة غير موجودة',
  MP000: 'الخدمة غير متاحة من المصدر',
  MP001: 'رمز التحقق المرئي غير صحيح',
  MP002: 'بيانات الهوية غير موجودة',
  MP003: 'المدخل غير صحيح',
  MP004: 'تاريخ الوثيقة غير صحيح',
  MP006: 'رقم الطلب غير صحيح',
  MP007: 'نوع الخصم غير صحيح',
  MP008: 'غير مصرح للوصول',
  MP009: 'التسعيرة غير صالحة',
  MP010: 'يوجد خطأ في رقم الآيبان',
  MP011: 'طريقة الدفع غير صحيحة',
  MP012: 'لا يوجد حقل بالأسم ({0}) و القيمة ({1})',
  MP013: 'الطلب منتهي الصلاحية',
  MP014: 'الطلب غير صالح',
  MP015: 'رقم الجوال مستخدم لصاحب وثيقة اخري',
  MP016: 'يرجى ادخال رقم الكفيل',
  MP017: 'رقم الكفيل المدخل غير صحيح، رجاء التحقق من الرقم و المحاولة مرة أخرى',
  MP018: 'يرجى ادخال تاريخ الميلاد',
  MP019:
    'تاريخ الميلاد غير صحيح، رجاء التحقق من شهر وسنة الميلاد و المحاولة مرة أخرى',
  MP020: 'يرجى ادخال رقم الهوية او الإقامة',
  MP021: 'الرقم المدخل غير صحيح، رجاء التحقق من الرقم و المحاولة مرة أخرى',
  MP022:
    'البيانات المدخلة غير متطابقة مع البيانات المسجلة في مركز المعلومات الوطني، رجاء التحقق من البيانات و المحاولة مرة أخرى',
  MP023: 'سن طالب التأمين يجب أن يكون {0} سنة أو أكثر',
  MP024: 'الحد الأدنى لعمر مالك الوثيقة للزائر هو {0} سنة',
  MP025: 'بيانات التخصص الطبي غير صحيحة',
  MP026: 'بيانات تصريحات مالك الوثيقة غير صحيحة',
  MP027: 'وثيقة تأمين سابقة غير صحيحة',
  MP028: 'رمز غير صحيح',
  MP029: 'قيمة الفاتورة غير صحيحة',
  MP030: 'التصريحات غير صحيحة',
  MP031: 'بيانات شركة التأمين غير صحيحة',
  MP032:
    'نعتذر عن عدم إمكانية إستكمال الطلب لعدم إرتباط رقم الجوال برقم الهوية/رقم الإقامة لمالك الوثيقة ، رجاء تزويدنا برقم جوال مملوك لمالك الوثيقة',
  MP033: 'لم يتم العثور على فاتورة الطلب',
  MP034: 'هناك مراجعه لعمليه الدفع لهذا الطلب قيد التفيذ',
  MP038: 'عدد الاماكن لا يمكن ان يزيد عن {0}',
  MP039: 'نوع المكان غير موجود',
  MP040: 'الوثيقة غير موجودة',
  MP042: 'بيانات الدفع غير موجودة',
  MP043: 'بيانات الفاتورة غير موجودة',
  MP044: 'رقم الجوال غير صحيح',
  PolicyHolderIsBlocked:
    'نعتذر عن عدم إمكانية إستكمال طلبك، للحصول على المزيد من المعلومات يمكنك التحدث مع خدمة العملاء',
  specialty_required: 'التخصص مطلوب',
  birth_date_not_correct_error: 'يرجى التأكد من صحة رقم الهوية وتاريخ الميلاد',
  national_address_not_found: 'بيانات العنوان الوطني غير موجودة',
  'national-address-not-found': 'بيانات العنوان الوطني غير موجودة',
  national_address_already_exists: 'العنوان الوطني موجود بالفعل لهذا الطلب',
  cancellation_request_already_exists:
    'يوجد طلب إلغاء قائم بالفعل لهذه الوثيقة',
  BUILDING_NUMBER_INVALID_LENGTH: 'رقم المبنى يجب ألا يزيد عن 4 أرقام',
  city_not_found_in_address: 'بيانات المدينة غير موجوده في العنوان',
  district_not_found_in_address: 'بيانات الحي غير موجوده في العنوان',
  quotation_not_found: 'رقم التسعيره غير صحيح',
  mobile_number_notVerified: 'لم يتم التحقق من رقم الجوال',
  failed_to_download_file: 'فشل في تحميل الملف أو أن الملف غير موجود',
  REDEMPTION_VALIDATION_ERROR: 'الحد الأدنى للنقاط المطلوبة: {0}',
  PASSPORT_DETAILS_ARE_REQUIRED_FOR_ALL_TRAVELERS:
    'بيانات جواز السفر مطلوبة لكل مسافر من أجل اصدار الوثيقة',
  T071: 'يوجد دفعة نشطة معلقة للفاتورة. يرجى الإنتظار حتى يتم إنهاء الدفع الحالي أو التواصل مع خدمة العملاء.',
  O002: 'رمز التحقق غير صحيح',
  O005: 'لقد انتهت صلاحية رمز التحقق',
  O003: 'تم تجاوز عدد المحاولات المسموح بها للتحقق من رمز التحقق',
  IBAN_VERIFICATION_ERROR:
    'فشل التحقق من الآيبان، يرجى التحقق من الآيبان والمحاولة مرة أخرى',
  USER_BLOCKED:
    'لقد تجاوزت عدد المحاولات المسموح بها للتحقق من رقم الآيبان الخاص بك.\nيرجى الانتظار {{duration}} قبل إعادة المحاولة.\nالرجاء التأكد من إدخال رقم آيبان المسجل لحامل الوثيقة.',
  INTERNAL_SERVER_ERROR: 'هناك خطأ ما',
  policy_related_to_other_identity: 'الوثيقة مرتبطة برقم هوية آخر',
  invalid_retroactive_date: 'لا يمكن أن يكون تاريخ الأثر الرجعي في المستقبل',
} as const
